/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import ModalDialog from './ModalDialog';
import {setModalOpenStatus} from "../../../_actions/modal.actions";
function mapStateToProps(state) {
    return {
        isModalOpen: state.modal.isModalOpen,
        hideModal: state.modal.hideModal
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalOpenStatus : (isOpen) => {
            dispatch(setModalOpenStatus(isOpen));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalDialog);


// WEBPACK FOOTER //
// ./src/components/widgets/ModalDialog/ModalDialogLink.js